import { render, staticRenderFns } from "./task-overview.vue?vue&type=template&id=498ef4b4&scoped=true"
import script from "./task-overview.vue?vue&type=script&lang=js"
export * from "./task-overview.vue?vue&type=script&lang=js"
import style0 from "./task-overview.vue?vue&type=style&index=0&id=498ef4b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ef4b4",
  null
  
)

export default component.exports